module.exports = __webpack_public_path__ + "static/media/Vectoric_visibility.b1c881c5.svg";